module.exports = __webpack_public_path__ + "static/polar-extraimg3@2x-min-9211ff2ade6f53b83902cf0e9db8c7ed.png";